import { Node } from 'tiptap';
import { wrappingInputRule, setBlockType, toggleWrap } from 'tiptap-commands';

export default class BootstrapBlockquoteNode extends Node {

  // choose a unique name
  get name() {
    return 'boostrapblockquote';
  }

  // the prosemirror schema object
  // take a look at https://prosemirror.net/docs/guide/#schema for a detailed explanation
  get schema() {
    return {
      content: 'block+',
      group: 'block',
      defining: true,
      draggable: false,
      // define how the editor will detect your node from pasted HTML
      // every blockquote tag will be converted to this blockquote node
      parseDOM: [
        { tag: 'blockquote' }
      ],
      // this is how this node will be rendered
      // in this case a blockquote tag with a class called `blockquote` will be rendered
      // the '0' stands for its text content inside
      toDOM: () => ['blockquote', { class: 'blockquote' }, 0]
    };
  }

  // this command will be called from menus to add a blockquote
  // `type` is the prosemirror schema object for this blockquote
  // `schema` is a collection of all registered nodes and marks
  public commands({ type, schema }: any) {
    return () => toggleWrap(type);
  }

  // here you can register some shortcuts
  // in this case you can create a blockquote with `ctrl` + `>`
  public keys({ type }: any) {
    return {
      'Ctrl->': toggleWrap(type)
    };
  }

  // a blockquote will be created when you are on a new line and type `>` followed by a space
  public inputRules({ type }: any) {
    return [
      wrappingInputRule(/^\s*>\s$/, type)
    ];
  }

}
